import { API } from '@grafana/faro-web-sdk';
import { isKnownError } from '@olo-web/utils/common/functions/isKnownError';
import { getClientEventManager } from './clientEventManager';

export enum EventType {
  ERROR = 'error',
  EVENT = 'event',
  IDENTIFY = 'identify_user',
  REMOVE = 'remove_user',
}

export interface Context {
  source: string;
  payload: any;
}

export const sendPrometheusEvent = (eventType: EventType, eventName: string): void => {
  try {
    getClientEventManager().queueEvent(`${eventType}:${eventName}`);
  } catch (_e) {
    // ignore as optional
  }
};

export const sendFaroEvent = (eventType: EventType, eventName: string, ctx?: Context): void => {
  try {
    if (!('faro' in window)) {
      return;
    }

    const faroAttributes: Record<string, string> = {
      source: ctx?.source || 'browser',
    };
    const allTags = ctx?.payload || {};
    for (const key in allTags) {
      if (typeof allTags[key] === 'string') {
        faroAttributes[key] = allTags[key];
      } else if (typeof allTags[key] === 'number') {
        faroAttributes[key] = allTags[key].toString();
      } else if (typeof allTags[key] === 'boolean') {
        faroAttributes[key] = allTags[key] ? '1' : '0';
      }
    }
    // @ts-ignore known typing
    const faroApi = window.faro.api as API;
    faroApi.pushEvent(`${eventType}:${eventName}`, faroAttributes, 'olo-web-refactor');
    if (eventType === EventType.IDENTIFY) {
      faroApi.setUser({
        email: allTags.email,
        id: allTags.id,
      });
    }
    if (eventType === EventType.REMOVE) {
      faroApi.resetUser();
    }
    // faroApi.pushMeasurement is stored in loki, not prometheus; thus ClientEventManager
  } catch (_e) {
    // ignore as optional
  }
};

export const sendClientEvent = (eventType: EventType, eventName: string, ctx?: Context): void => {
  sendPrometheusEvent(eventType, eventName);
  sendFaroEvent(eventType, eventName, ctx);
};

export const trackClientError = (err: Error, ctx?: Context): void => {
  if (isKnownError(err.message)) {
    return;
  }
  sendClientEvent(EventType.ERROR, err.toString(), ctx);
};

export const trackClientEvent = (actionName: string, ctx?: Context): void => {
  sendClientEvent(EventType.EVENT, actionName, ctx);
};

type TDDIdentify = {
  email?: string;
  id?: string;
  name?: string;
};
export const identifyClientUser = (tddIdentify: TDDIdentify) => {
  sendClientEvent(EventType.IDENTIFY, EventType.IDENTIFY, {
    source: 'browser',
    payload: tddIdentify,
  });
};

export const removeClientUser = () => {
  sendClientEvent(EventType.REMOVE, EventType.REMOVE, {
    source: 'browser',
    payload: {},
  });
};
